import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import IHowToApply from '@/models/viewModels/IHowToApply';
import Markdown from 'markdown-to-jsx';
import {
  HowToApplyIcon,
  PostOfferProcessIcon,
  PreparingForArrivalIcon,
} from '@/components/atoms/icons';
import HowToApplyTitle from '@/components/atoms/de-uni/how-to-apply-title/how-to-apply-title';
import styles from './how-to-apply.module.scss';

type Props = {
  howToApply: IHowToApply[];
};

const titles = {
  howToApply: {
    mainHeadline: `How to apply`,
    icon: <HowToApplyIcon />,
    howToApply: null,
    applicationDeadlines: `Application deadlines`,
    documents: `Application documents required to receive an offer`,
    testingCodes: `Testing codes`,
  },
  postOfferProcess: {
    mainHeadline: `Post-offer process`,
    icon: <PostOfferProcessIcon />,
    confirmationDeadlines: `Confirmation deadlines`,
  },
  preparingForArrival: {
    mainHeadline: `Preparing for arrival`,
    icon: <PreparingForArrivalIcon />,
    beforeArrival: `Before arrival`,
    afterArrival: `After arrival`,
  },
};

export default function HowToApply({ howToApply }: Props) {
  return (
    <section className="mt-5" id="how-to-apply">
      <h2 className="mb-3">How to apply</h2>
      <Tabs defaultActiveKey="0">
        {howToApply.map((el, i) => (
          <Tab key={el.tabName} id={el.tabName} eventKey={i.toString()} title={el.tabName}>
            <div id={`how-to-apply-${el.tabName}`}>
              {Object.keys(el.content).map((key) =>
                el.content[key] ? (
                  <div
                    key={`${el.tabName}-${el.content[key]}-${key}`}
                    id={`${el.tabName}-${key}-block`}
                    className={styles.content}
                  >
                    <HowToApplyTitle icon={titles[key].icon} headline={titles[key].mainHeadline} />
                    {Object.keys(el.content[key]).map((prop) =>
                      el.content[key][prop] ? (
                        <div
                          id={`${el.tabName}-${prop}`}
                          key={`${el.tabName}-${el.content[key][prop]}`}
                          className={styles[`content-child`]}
                        >
                          {titles[key][prop] ? <h4>{titles[key][prop]}</h4> : null}
                          <Markdown className="pre-wrap">{el.content[key][prop]}</Markdown>
                        </div>
                      ) : null,
                    )}
                  </div>
                ) : null,
              )}
            </div>
          </Tab>
        ))}
      </Tabs>
    </section>
  );
}
